import trim from 'locutus/php/strings/trim';
import ltrim from 'locutus/php/strings/ltrim';
import rtrim from 'locutus/php/strings/rtrim';
import ucfirst from 'locutus/php/strings/ucfirst';
import lcfirst from 'locutus/php/strings/lcfirst';
import numberFormat from 'locutus/php/strings/number_format';

export {
	trim,
	ltrim as leftTrim,
	rtrim as rightTrim,
	ucfirst as ucFirst,
	lcfirst as lcFirst,
	numberFormat,
};

/**
 * Utility to transform a camelCase string in a lowercase version with words separated by a given
 * char
 *
 * @export
 * @param {string} value camelCase string to be converted
 * @param {string} [separator='-'] separator char to be used
 * @returns {string} the converted string
 */
export function decamelize(value, separator = '-') {
	return value.replace(/([a-z0-9]+)([A-Z]+)/g, '$1' + separator + '$2').toLowerCase();
}

/**
 * Utility to transform a dash or underscore separated string to a camelCase formatted string
 *
 * @export
 * @param {string} value dash or undescore separated string
 * @param {boolean} [setUcFirst=false] true when we want the returned string to start with an upper case char
 * @returns {string} the camelCase string
 */
export function camelize(value, setUcFirst = false) {
	value = value.replace(/[-_]+([a-z0-9])/gi, (all, letter) => letter.toUpperCase());
	return setUcFirst ? ucfirst(value) : value;
}
